import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import ListItemIcon from '@mui/material/ListItemIcon';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import AgriPixLogo from '../../assets/icons/AgriPix_logo.svg';
import { useMsal } from '@azure/msal-react';
import { useAppDispatch } from '../../storeHook';
import { deleteToken } from '../../reduxActions/tokenSlice';
import {
  appLogEvent,
  CUSTOM_EVENTS,
} from '../../utils/analytics';
import { useGetUserDetailsQuery } from '../../services/user';
import { Users } from '../../pages/users';
import { getFormattedUserName } from '../../utils/functions/common';
import { resetAuthUser } from '../../services/slices/authUserSlice';
import { AppCircularProgress } from '../AppCircularProgress';
import AppTheme from './appTheme';
import { useNavigate } from 'react-router-dom';
import './index.scss';
// import { LanguageSelect } from '../languageSelect';

export default function AppHeader() {
  const [anchorEl, setAnchorEl] =
    React.useState<null | HTMLElement>(null);

  const { instance } = useMsal();
  const dispatch = useAppDispatch();

  const handleMenu = (
    event: React.MouseEvent<HTMLElement>
  ) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onLogoutClick = () => {
    appLogEvent(CUSTOM_EVENTS.LOG_OUT);
    instance.logoutRedirect({
      onRedirectNavigate: () => {
        // Return false if you would like to stop navigation after local logout
        return false;
      },
    });
    localStorage.removeItem('authToken');
    dispatch(deleteToken());
    dispatch(resetAuthUser());
    window.location.reload();
  };

  const [isLoadingUsersList, setIsLoadingUsersList] =
    React.useState(false);
  const { data: userDetails } = useGetUserDetailsQuery();
  const userName = getFormattedUserName(userDetails?.name);
  const navigate = useNavigate();
  const handleBackNavigation = () => {
    navigate('/');
  };
  return (
    <div
      style={{ minHeight: '64px' }}
      className="header-container">
      {isLoadingUsersList && <AppCircularProgress />}
      <AppBar position="relative" className="app-bar">
        <Toolbar className="flex fleflex md:ml-auto justify-between md:justify-end w-full items-centerx-col md:flex-row">
          <img
            src={AgriPixLogo}
            className="w-[159.49px] h-[45.25px] object-contain cursor-pointer"
            onClick={handleBackNavigation}
          />
          <div className="flex md:ml-auto justify-between md:justify-end w-full items-center">
            <AppTheme />
            {/* <LanguageSelect /> */}
            <div className="my-auto md:ml-6">
              <span
                className="profile-icon"
                style={{
                  padding: '4px',
                  borderRadius: '5px',
                  marginRight: '7px',
                  cursor: 'pointer',
                }}
                onClick={handleMenu}>
                {userName?.shortName || 'CU'}
              </span>
              <Typography
                className="user-name"
                variant="h6"
                component="span"
                sx={{
                  flexGrow: 1,
                  fontWeight: 600,
                  fontSize: '13px',
                }}>
                {userName?.name || 'Current User'}
              </Typography>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}>
                <div>
                  <MenuItem onClick={onLogoutClick}>
                    <ListItemIcon>
                      <PowerSettingsNewIcon />
                    </ListItemIcon>{' '}
                    Logout
                  </MenuItem>
                  {userDetails?.role === 'admin' && (
                    <Users
                      closeAnchorEle={handleClose}
                      setIsLoadingUsersList={
                        setIsLoadingUsersList
                      }
                    />
                  )}
                </div>
              </Menu>
            </div>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
}
